import React,{useState,useEffect,useCallback, useRef } from 'react';
import { toJpeg } from 'html-to-image';
import '../App.css';
import Header from '../component/Header';
import modelDataEN from '../data/en/model.json';
import modelDataTH from '../data/th/model.json';
import modelDataVN from '../data/vn/model.json';
import modelDataAR from '../data/ar/model.json';
import {useTranslation} from 'react-i18next'
import axios from 'axios';
import parse from 'html-react-parser'
let modelData:any={}
let placement:any = sessionStorage.getItem("placement")
let pbg:string="";
let productImage:string="";
let bgStyle:string="";
function Result() {
  let{t} = useTranslation()
  if(sessionStorage.getItem("lang")==="th"){
    modelData = modelDataTH
  }else if(sessionStorage.getItem("lang")==="vn"){
    modelData = modelDataVN
  }else if(sessionStorage.getItem("lang")==="ar"){
    modelData = modelDataAR
  }else{
    modelData = modelDataEN
  }
  if(placement.toString()==="3"){
    pbg= "images/bg_classic.png" 
    bgStyle = "classic";
  }else if(placement.toString()==="2"){
    pbg= "images/bg_bright.png";
    bgStyle = "bright";
  }else{
    pbg= "images/bg_modern.png";
    bgStyle = "modern";
  }
  const[imgFile,setImgFile]=useState("")
  const[bg,setBg]=useState(pbg)
  const ref = useRef<HTMLDivElement>(null)
  const filter:any =  modelData.filter((item:any)=>{ 
    return  item.id.toString()===sessionStorage.getItem("model")
   })
   const[item,setItem]=useState(filter[0])
   const[hideButton,setHideButton]=useState(false)
   const[itemImage,setItemImage]=useState(item.image)
   const[color,setColor]=useState(filter[0].color[0].code)
   const[hitachi,setHitachi]=useState("images/logo.png")
   const[shareImage,setShareImage]=useState("https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+bgStyle+"/"+filter[0].type.replaceAll(' ','')+"/"+filter[0].color[0].code+".html")
   const focusDiv:any = useRef();
   const scrollToRef = (ref:any) => {
    window.scrollTo(0, ref.current.offsetTop);  
  }
  productImage = item.image
  
   const onButtonClick =   () => {
      let style:string="";
      let pcolor:string=color;
      if(placement.toString()==="3"){
        style= "classic" 
      }else if(placement.toString()==="2"){
        style= "bright";
      }else{
        style= "modern";
      }

      if(pcolor===""){
        pcolor = item.color[0].code;
      }
      let itemCode:string=item.type
      let imageUrl:string="images/result/"+style+"/"+itemCode.replaceAll(' ','')+"/"+pcolor+".png";

      
      if(item.model==="R-WB480"){
        imageUrl= "images/result/"+style+"/"+itemCode.replaceAll(' ','')+"480/"+pcolor+".png";
      }else if(item.model==="R-WB550"){
        imageUrl= "images/result/"+style+"/"+itemCode.replaceAll(' ','')+"550/"+pcolor+".png";
      }else{
        imageUrl= "images/result/"+style+"/"+itemCode.replaceAll(' ','')+"/"+pcolor+".png";
      }
      let shareUrl:string="https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+style+"/"+itemCode.replaceAll(' ','')+"/"+pcolor+".html";
       
      if(item.model==="R-WB480"){
       shareUrl="https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+style+"/"+itemCode.replaceAll(' ','')+"480/"+pcolor+".html";
      }else if(item.model==="R-WB550"){
        shareUrl="https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+style+"/"+itemCode.replaceAll(' ','')+"550/"+pcolor+".html";
      }else{
        shareUrl="https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+style+"/"+itemCode.replaceAll(' ','')+"/"+pcolor+".html";
      }
      setShareImage(shareUrl)
      console.log("resp",imageUrl)
      const link = document.createElement('a')
        console.log(imageUrl) 
        link.download = 'My-Hitachi-Refrigerator.jpg'
        link.href = imageUrl
        link.click()
      /*axios.post('api.php',{bg:bg,item:itemImage})
      .then(res => {
        console.log("resp",res)
        const link = document.createElement('a')
        // console.log(dataUrl) 
         link.download = 'My-Hitachi-Refrigerator.jpg'
         link.href = res.data
         link.click()
      })*/
 
    
  } 

  const onSelectColor=(color:string)=>{
    setColor(color)
    let itemCode:string=item.type
    let image:string= "images/model/"+itemCode.replaceAll(' ','')+"/"+color+".png";
    if(item.model==="R-WB480"){
       image= "images/model/"+itemCode.replaceAll(' ','')+"480/"+color+".png";
    }else if(item.model==="R-WB550"){
       image= "images/model/"+itemCode.replaceAll(' ','')+"550/"+color+".png";
    }else{
       image= "images/model/"+itemCode.replaceAll(' ','')+"/"+color+".png";
    }
    productImage = image
    setItemImage(image);
    scrollToRef(focusDiv)
    setImgFile("")
    
    
  }
  const onRestart=()=>{
    sessionStorage.clear()
    sessionStorage.setItem("lang", "ar");
    window.location.href="/ae/ar/choose-your-refrigerator"
  }
  const getBase64FromUrl = async (url:string) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob); 
      reader.onloadend = () => {
        const base64data = reader.result;   
        resolve(base64data);
      }
    });
  }
 
 
  
   useEffect(()=>{
    let imageUrl:string="https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+bgStyle+"/"+item.type.replaceAll(' ','')+"/"+color+".html";
    if(item.model==="R-WB480"){
      imageUrl="https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+bgStyle+"/"+item.type.replaceAll(' ','')+"480/"+color+".html";
     }else if(item.model==="R-WB550"){
       imageUrl="https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+bgStyle+"/"+item.type.replaceAll(' ','')+"550/"+color+".html";
     }else{
       imageUrl="https://hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/refrigerator/"+bgStyle+"/"+item.type.replaceAll(' ','')+"/"+color+".html";
     }
      setShareImage(imageUrl)
     
    
   },[color])
    return (
        <div className="App container-fuild" ref={focusDiv}>
          <Header/>
          <div   className="pb-2 px-3">
          <div className="container-content c-result" >
            <div className="container-block ">
              <div>
                <div className="container m-auto py-2 px-2">
                    <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 px-5 mb-2 p-relative productimage" >
                      <div className='p-relative' ref={ref}>
                        <img src={bg} alt="" className='w-100'/>
                        <img src={itemImage} alt="" className={`bg-${placement}`}/>
                      </div>
                      <div className="col-12  color my-3 mobile-color"> 
                                <div className='ul-color row'>
                                  {
                                    (item.color.map((cl:any,key:number)=>
                                    <div key={`color${key}`} className={`col-12 col-sm-6 col-md-6 col-lg-6 ${(cl.code===color)?"active":""}`}><label className={`${cl.code} ${(cl.code===color)?"active":""}`}  onClick={()=>onSelectColor(cl.code)}></label> {cl.name}</div>
                                    ))
                                  }
                                </div>
                              </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 model-desc mb-0">
                        <div className="row m-0">
                              <div className="col-12 mb-2 py-1 right-border">
                                 {item.model} <span className='text-uppercase'>{t("model")}</span>
                              </div>
                              <div className="col-12 mb-2 py-1 px-0">
                                <table className='tbl-model w-100 ' cellPadding={1} cellSpacing={1}>
                                    <thead>
                                    <tr>
                                        <th>{t("door")}</th>
                                        <th>{t("volume")}</th>
                                        <th>{t("freezer")}</th>
                                        <th>{t("dimension")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>{item.door}</td>
                                        <td>{item.volume}</td>
                                        <td>{item.position}</td>
                                        <td>{item.width}*{item.depth}*{item.height}</td>
                                        </tr>
                                    </tbody>
                                </table>
                              </div>
                              <div className="col-12 mb-2 py-1 right-border">
                                <span className='text-uppercase'>{t("feature")}</span>
                              </div>
                              <div className="col-12  px-0">
                                    <div className="row justify-content-end">
                                      {
                                        (item.auto_ice_maker)?
                                        <div className="col-4 fetaure-item mb-3">
                                            <img src="images/icon/ice.png" alt=""  className='align-middle'/>
                                            <label  className='align-middle'>{t("f_ice")}</label>
                                        </div>
                                        :<></>
                                      }
                                      {
                                        (item.water_dispenser)?
                                        <div className="col-4 fetaure-item mb-3">
                                            <img src="images/icon/water.png" alt=""  className='align-middle'/>
                                            <label  className='align-middle'>{t("f_water")}</label>
                                        </div>
                                        :<></>
                                      }
                                      {
                                        (item.auto_door_opening)?
                                        <div className="col-4 fetaure-item mb-3">
                                            <img src="images/icon/hand.png" alt=""  className='align-middle'/>
                                            <label  className='align-middle'>{t("f_door")}</label>
                                        </div>
                                        :<></>
                                      }
                                      {
                                        (item.vacuum_compartment)?
                                        <div className="col-4 fetaure-item mb-3">
                                            <img src="images/icon/air.png" alt=""  className='align-middle'/>
                                            <label  className='align-middle'>{t("f_vacuum")}</label>
                                        </div>
                                        :<></>
                                      }
                                      {/* {
                                        (item.iot)?
                                        <div className="col-4 fetaure-item mb-3">
                                            <img src="images/icon/wifi.png" alt=""  className='align-middle'/>
                                            <label  className='align-middle'>{t("f_iot")}</label>
                                        </div>
                                        :<></>
                                      } */}
                                    </div>
                              </div>
                              <div className="col-12 py-2 right-border desk-color">
                                <span className='text-uppercase'>{t("color")}</span>
                              </div>
                              <div className="col-12  color mb-3 desk-color">
                                <p className='mb-0 text-end'>{t("choose_color")}</p>
                                <div className='ul-color row justify-content-end'>
                                  {
                                    (item.color.map((cl:any,key:number)=>
                                    <div key={`color${key}`} className={`col-12 col-sm-6 col-md-6 col-lg-6 ${(cl.code===color)?"active":""}`}><label className={`${cl.code} ${(cl.code===color)?"active":""}`}  onClick={()=>onSelectColor(cl.code)}></label> {cl.name}</div>
                                    ))
                                  }
                                </div>
                              </div>
                              <div className={`col-12 text-start px-0 action ${(hideButton)?"d-none":"d-block"}`}>
                                    <button className='btn btn-download mb-1' onClick={onButtonClick}> <img src=". ./images/download.png" alt="" onClick={onButtonClick} /> {t("download")}</button>
                                    <a className='btn btn-view  mb-1' href={item.produc_url} target="_blank" rel="noreferrer">{t("view")}</a>
                               </div> 
                              
                        </div>
                        
                    </div>
                    </div>
                </div>
              </div>
              <div className={`share-block ${(hideButton)?"d-none":"d-block"} ${(sessionStorage.getItem("lang")==="th")?"th-share-block":""}  ae-share-block `}>
                  <p>{parse(t("share"))}</p>
                  <ul className='social'>
                      {/* <li><a href="https://www.facebook.com/sharer/sharer.php?u=https://hitachi-homeappliances.com&hashtag=%23MyHitachiRefrigerator%23TulanhHitachi"><img src="images/ig.png" alt="" /></a></li> */}
                      <li><a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${shareImage.replaceAll('+','PLUS')}&hashtag=%23MyHitachiRefrigerator%23TulanhHitachi`}><img src="images/fb.png" alt="" /></a></li>
                      <li><a target="_blank" href={`https://twitter.com/intent/tweet?url=${shareImage.replaceAll('+','PLUS')}&text=انظر ، ها هي ثلاجة هيتاشي الخاصة بي!`}><img src="images/tw.png" alt="" /></a></li>
                  </ul>   
              </div> 
            </div>
            <ul className={`step finish ${(hideButton)?"d-none":"d-block"}`}>
              <li>1</li>
              <li>2</li>
              <li>3</li>
              <li >4</li>
              <li className='active text-uppercase red-color'>{t("finish")}</li>
            </ul>
            </div>
            
          </div>
          <div className="row w-100 mx-0 mb-5">
            <div className="col-12 text-center">
                <a className='btn btn-back' href='/ae/ar/choose-your-refrigerator/attention'>{t("back")}</a>
                <button className='btn btn-view btn-restart mr-0' onClick={()=>onRestart()}>{t("restart")}</button>
            </div>
           </div>
        </div>
      );
}

export default Result;
